import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../services/api';
import config from '../config';

export const useMe = function () {
  const token = localStorage.getItem('token');
  return useQuery(['me'], () =>
    fetch('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((r) => r.data),
  );
};

export const useGoogleLogin = () => {
  const qc = useQueryClient();
  const { login } = useAuth();
  const navigate = useNavigate();

  // 1️⃣ send ID‑token -> backend
  return useMutation(
    async (token) => {
      return apiRequest(`${config.apiUrl}/auth/google`, {
        body: JSON.stringify({ token: token }),
        method: 'POST',
      });
    },
    {
      mutationKey: ['googleLogin'],
      onSuccess: (data) => {
        login(data.token, data.user);
        qc.invalidateQueries(['me']);
        navigate('/');
      },
      onError: (error) => {},
    },
  );
};
